module.exports = __webpack_public_path__ + "img/trash.907db4ed.svg";